import { filter } from 'lodash';
import Vue from 'vue';

import SystemUserPushApi from 'client/api/v2/SystemUserPushApi';

export default {
  namespaced: true,

  state: {
    endpoints: [],
  },

  actions: {
    async getDeviceEndpoints({ commit, dispatch }, id) {
      try {
        const deviceEndpoints = await SystemUserPushApi.getDeviceEndpoints(id);

        commit('SET_DEVICE_ENDPOINTS', deviceEndpoints);
      } catch (error) {
        dispatch(
          'AlertModule/triggerErrorAlert',
          'Failed to load JumpCloud Protect device endpoints.',
          { root: true },
        );
      }
    },

    async deleteDeviceEndpoint({ commit, dispatch }, { userId = '', endpointId = '' }) {
      try {
        const deletedEndpoint = await SystemUserPushApi.deleteDeviceEndpoint(userId, endpointId);

        commit('REMOVE_DEVICE_ENDPOINT_BY_ID', deletedEndpoint.id);
        dispatch(
          'AlertModule/triggerSuccessAlert',
          'JumpCloud Protect device successfully deleted.',
          { root: true },
        );
      } catch (error) {
        dispatch(
          'AlertModule/triggerErrorAlert',
          'Failed to delete JumpCloud Protect device.',
          { root: true },
        );
      }
    },
  },

  mutations: {
    SET_DEVICE_ENDPOINTS(state, endpoints = []) {
      Vue.set(state, 'endpoints', endpoints);
    },
    REMOVE_DEVICE_ENDPOINT_BY_ID(state, deviceId) {
      Vue.set(
        state,
        'endpoints',
        filter(state.endpoints, endpoint => endpoint.id !== deviceId),
      );
    },
  },
};
